// extracted by mini-css-extract-plugin
export default {"loading":"myFeedbackList_loading__3VYNL","pcWrap":"myFeedbackList_pcWrap__vK7oR"};